<template>
  <div class="div-componentePCUltimosVolcados">
    <!-- No existen registros de volcado -->
    <PCInformacionSinRegistros v-if="(volcados === null || volcados.length === 0) && !mostrarPrecarga && filtro == null" />
    <!-- No existen registros en la busqueda -->
    <UCInformationWithoutSearchRecord v-if="(volcados === null || volcados.length === 0) && !mostrarPrecarga && filtro != null" />

    <!-- Preloader de carga -->
    <UCPreload :show="mostrarPrecarga" />

    <!-- Existen registros de volcados -->
    <!-- VOLCADOS: <pre> {{ volcados }} </pre> -->

    <div
      v-if="volcados != null"
      class="div-registrosDeMovimientos"
    >
      <f7-list
        v-for="volcado in volcados "
        :key="volcado.Lote.Id"
        class="Lote"
      >
        <div>
          <f7-list-item

            class="list item-inner"
          >
            <img
              v-if="ComprobarFechaFin(volcado.FechaFin)"
              src="@/static/img/ic_eclipseAmarillo.svg"
              alt="Ellipse"
            >
            <img
              v-if="!ComprobarFechaFin(volcado.FechaFin)"
              src="@/static/img/ic_eclipseGris.svg"
              alt="Ellipse"
            >
            <span class="styleLote">
              {{ `${$t('production.common.currentLot')} ${volcado.Lote.Codigo}` }}
            </span>
          </f7-list-item>
          <div
            v-for="colaVolcado in volcado.ColasVolcado "
            :key="colaVolcado.Id"
            class="div-registroMovimiento"
            @click="VerDetalleVolcado(colaVolcado)"
          >
            <!-- <pre>{{colaVolcado}}</pre> -->
            <f7-row class="no-padding">
              <f7-col
                class="div-horaRegistroMovimientoYPartida"
                width="80"
              >
                <div class="div-horaRegistroMovimiento">
                  {{ FormatearFecha(colaVolcado.FechaInicio) }}
                </div>
                <div
                  class="div-numeroPartida"
                >
                  <span class="span-numeroPartida"> {{ colaVolcado.ArticuloNumeroSerieVolcado != null ? colaVolcado.ArticuloNumeroSerieVolcado.NumeroSerie : '' }}
                  </span>
                  <br>
                </div>
              </f7-col>
              <f7-col
                width="20"
                class="col-ttlVolcadoORecuperado"
              >
                <span v-if="colaVolcado.CantidadEnvases > 0">{{ $t('production.common.dumped') }} </span>
                <span v-if="colaVolcado.CantidadEnvases < 0">{{ $t('production.common.retrieved') }} </span>
              </f7-col>
            </f7-row>
            <f7-row
              class="row-nombreProductoYCantidadEnvases no-padding"
            >
              <f7-col
                width="80"
                class="col-productoRegistroMovimiento"
              >
                {{ colaVolcado.Producto != null ? colaVolcado.Producto.Nombre : '' }}
              </f7-col>
              <f7-col
                width="20"
                class="col-cantidadEnvasesVolcado"
              >
                <span
                  v-if="colaVolcado.CantidadEnvases > 0"
                  class="span-ttl-unidades-volcadas"
                >{{ colaVolcado.CantidadEnvases }} </span>
                <span
                  v-if="colaVolcado.CantidadEnvases < 0"
                  class="span-ttl-unidades-recuperadas"
                >{{ colaVolcado.CantidadEnvases }} </span>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </f7-list>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCInformacionSinRegistros from '@/components/production/traceability/PCInformacionSinRegistros.vue';
import HIConversionSupport, { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import UCInformationWithoutSearchRecord from '@/components/common/UCInformationWithoutSearchRecord.vue';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCUltimosVolcadosLote',
  components: {
    PCInformacionSinRegistros,
    UCInformationWithoutSearchRecord,
    UCPreload,

  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    filtro: {
      type: Array,
      default: () => [],
    },
  },

  emits: [
    'volcadoSeleccionado',
    'loteActivo',
  ],

  data() {
    return {
      puntoDeVolcado: null,
      lineaProduccion: null,
      volcados: null,
      seleccionVolcado: null, // Contiene el elemento de volcado seleccionado.
      mostrarPrecarga: false, // Muestra el componente de precargadatosPersonalizaciones: [],
      datosPersonalizaciones: [],
      personalizacionVolcadoLotesActivos: false,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),
  },
  watch: {
    activo(val) {
      if (val) {
        this.ObtenerPuntoDevolcadoSeleccionado();
        this.ObtenerLineaDeProduccionSeleccionada();
        this.InicializarComponente();
      }
    },
    volcados(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerLoteActivo(val);
      }
    },
    cantidadCajasVolcar() {
      this.RecalcularCantidadesUnidadVolcado();
    },
    cantidadKilosVolcar() {
      this.RecalcularCantidadesUnidadVolcado();
    },
    filtro(val) {
      if (val != null) {
        this.AplicarFiltrado(val);
      } else {
        this.LimpiarFiltros();
      }
    },
  },
  created() {
    this.ObtenerPuntoDevolcadoSeleccionado();
    this.ObtenerLineaDeProduccionSeleccionada();
    this.InicializarComponente();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.ConfigurarPersonalizacionesFrm();
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.ObtenerMercanciaVolcada();
    },

    ConfigurarPersonalizacionesFrm() {
      Log(this, this.ConfigurarPersonalizacionesFrm.name);
      this.personalizacionVolcadoLotesActivos = SoportePersonalizacion.ExistePersonalizacion('frmVolcarMercanciaUnidadLogisticaLectura', 'PCUltimosVolcadosLote');
    },

    ObtenerPuntoDevolcadoSeleccionado() {
      Log(this, this.ObtenerPuntoDevolcadoSeleccionado.name);
      this.puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
    },

    ObtenerLineaDeProduccionSeleccionada() {
      Log(this, this.ObtenerLineaDeProduccionSeleccionada.name);
      this.lineaProduccion = this.lineaDeProduccionSeleccionada;
    },

    async ObtenerPersonalizacionesPlanificaciones(lstvolcados) {
      Log(this, this.ObtenerPersonalizacionesPlanificaciones.name);

      if (!this.personalizacionVolcadoLotesActivos) {
        return;
      } // Comprueba si esta activa.
      this.datosPersonalizaciones = [];
      const entidades = [];

      const arrayLstVolcados = lstvolcados.map((i) => [i.IdPartida, i]);

      const mapVolcados = new Map(arrayLstVolcados);

      const lstPVolcadosUnicos = [...mapVolcados.values()];

      lstPVolcadosUnicos.forEach((e) => {
        entidades.push({ Id: e.IdPartida });
      });

      this.datosPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmVolcarMercanciaUnidadLogisticaLectura', 'PCUltimosVolcadosLote');
    },
    async ObtenerMercanciaVolcada() {
      this.ObtenerPuntoDevolcadoSeleccionado();
      Log(this, this.ObtenerMercanciaVolcada.name);
      this.mostrarPrecarga = true;
      const result = await ConexionTA.callObtenerLotesVolcadosParaXPuntoVolcado(this.puntoDeVolcado.Id, new Date(), true);
      this.mostrarPrecarga = false;
      // Al ser volcados de NS agrupamos los volcados y recuperados que son del mismo movimiento en un mismo registro.
      this.volcados = this.AgruparVolcadosYRecuperados(result);
      // this.volcados = result;
      return result;
    },
    AgruparVolcadosYRecuperados(list) {
      Log(this, this.AgruparVolcadosYRecuperados.name);
      // Agrupamos por fecha de volcado.
      list.forEach((element) => {
        const colasAgrupadas = element.ColasVolcado.reduce((acc, cv) => {
          acc[cv.FechaInicio] ||= { FechaInicio: cv.FechaInicio, Cantidad: 0, CantidadEnvases: 0 };
          acc[cv.FechaInicio].Cantidad += cv.Cantidad;
          acc[cv.FechaInicio].CantidadEnvases += cv.CantidadEnvases;
          return acc;
        }, {});
          // Nos quedamos solo con el volcado o el recuperado.
        if (Object.keys(colasAgrupadas).length !== 0) {
          element.ColasVolcado = element.ColasVolcado.filter((cv) => {
            const agrupado = colasAgrupadas[cv.FechaInicio];
            if ((agrupado.Cantidad > 0 && cv.Cantidad > 0) || (agrupado.Cantidad < 0 && cv.Cantidad < 0)) {
              cv.Cantidad = agrupado.Cantidad;
              cv.CantidadEnvases = agrupado.CantidadEnvases;
              return true;
            }
            return false;
          });
        }
      });
      return list;
    },

    VerDetalleVolcado(colaVolcado) {
      Log(this, this.VerDetalleVolcado.name);

      this.seleccionVolcado = colaVolcado;
      // eventBus.emit('PCUltimosVolcados_volcadoSeleccionado', this.seleccionVolcado);
      this.$emit('volcadoSeleccionado', this.seleccionVolcado);
    },

    FormatearFecha(fechaYHora) {
      return HIConversionSupport.obtenerHorasYMinutos(fechaYHora);
    },

    CancelarProcesoDeRecuperado() {
      Log(this, this.CancelarProcesoDeRecuperado.name);
      this.actionsSeleccionRecuperado = false;
      this.mostrarRecuperadoParcialEnvases = false;
      this.mostrarRecuperadoParcialKilos = false;
    },

    AplicarFiltrado(filtro) {
      Log(this, this.AplicarFiltrado.name);
      // Busqueda nombre producto.
      if (filtro[0].CampoFiltrante === 'FamiliaArticulo') {
        this.AplicarFiltradoPorNombreFamilia(filtro);
        return;
      }
      // Busqueda por partida
      if (filtro[0].CampoFiltrante === 'IdentificadorUnicoCodigoDeBarras') {
        this.AplicarFiltradoPorPartida(filtro);
        return;
      }
      // Busqueda por Unidad Logistica
      if (filtro[0].CampoFiltrante === 'NumeroSerie') {
        this.AplicarFiltradoPorUnidadLogistica(filtro);
      }
    },

    AplicarFiltradoPorNombreFamilia(filtro) {
      Log(this, this.AplicarFiltradoPorNombreFamilia.name);
      const filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      this.volcados.forEach((vol) => {
        if (vol.FamiliaArticulo.Nombre.toLowerCase().search(filtroValor.toLowerCase()) !== -1) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },

    AplicarFiltradoPorPartida(filtro) {
      Log(this, this.AplicarFiltradoPorPartida.name);
      let filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      if (filtroValor.charAt(0) === '/') {
        filtroValor = filtroValor.substr(1);
      }
      this.volcados.forEach((vol) => {
        if (vol.IdentificadorPartida === filtroValor) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },

    AplicarFiltradoPorUnidadLogistica(filtro) {
      Log(this, this.AplicarFiltradoPorUnidadLogistica.name);
      const filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      this.volcados.forEach((vol) => {
        if (vol.NumeroSerie === filtroValor) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },

    LimpiarFiltros() {
      Log(this, this.LimpiarFiltros.name);
      this.ObtenerMercanciaVolcada();
    },

    ObtenerCadenaNumerosPartidas(lstPartidas) {
      Log(this, this.ObtenerCadenaNumerosPartidas.name);
      let cadenaPartidas = '';
      try {
        lstPartidas.forEach((p) => {
          const seriePartida = p.Partida.Serie != null ? p.Partida.Serie : '';
          cadenaPartidas += `${seriePartida}/${p.Partida.Numero}, `;
        });
        cadenaPartidas = cadenaPartidas.slice(0, -2); // Quitamos el último carácter.
      } catch (error) {
        LogError('No se pudo obetener cadena', error);
      }
      return cadenaPartidas;
    },
    ObtenerLoteActivo() {
      Log(this, this.ObtenerLoteActivo.name);
      let emitido = false;
      this.volcados.forEach((volcado) => {
        if (HiDateTimeSupport.IsNull(volcado.FechaFin)) {
          this.$emit('loteActivo', volcado.Lote);
          emitido = true;
        }
      });
      if (!emitido) {
        this.$emit('loteActivo', { Codigo: '' });
      }
    },
    ComprobarFechaFin(fecha) {
      Log(this, this.ComprobarFechaFin.name);
      return HiDateTimeSupport.IsNull(fecha);
    },
  },
};
</script>

<style scoped>
.div-registrosDeMovimientos {
  /* margin-top: 25px; */
  background: red;
  margin-top: 0;
}

.div-registroMovimiento {
  padding-right: 28px;
  padding-bottom: 10px;
  margin-top: 6px;
  border-bottom: 1px solid var(--his-disabled);
  margin-left: 28px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
}

.col-cantidadEnvasesVolcado {
  font-size: 26px;
  font-weight: 900;
  line-height: 29px;
  color: #66ba33;
  display: flex;
  justify-content: center;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-volcadas {
  color: #66ba33;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-recuperadas {
  color: var(--his-tomate);
}

.col-productoRegistroMovimiento {
  top: calc(50% - 16px / 2 + 3.5px);
  margin-left: 10px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  padding-top: 7px;
}

.col-ttlVolcadoORecuperado {
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  color: var(--his-plum-shadow);
  text-align: right;
  display: flex;
  justify-content: center;
}

.div-horaRegistroMovimientoYPartida {
  /* margin-left: 10px;
    margin-top: 7px; */
  display: flex;
}

.div-horaRegistroMovimiento {
  max-height: 21px;
}

.div-numeroPartida {
  margin-left: 20px;
}

.row-nombreProductoYCantidadEnvases {
  padding-bottom: 0;
}

.div-componenteInformacionSinRegistros {
  height: 64vh !important;
}

.Lote {
  background: var(--his-tierra-white);
}

.styleLote {
  margin-left: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: var(--his-darkgray);
}

.list .item-inner {
  position: relative;

  /* width: 100%; */
  background: var(--his-silver);
  min-width: 0;
  display: flex;
  justify-content: space-between;
}
</style>
